import { $axios } from "@/plugins/axios";
import { APIS } from "@/constants/apis";
import { getErrorMessageFromApi } from "@/helpers/apis";
import {
    validateSignupForm,
    validateSigninForm,
    validateChangePasswordForm,
    getAllFilledFields
} from "@/helpers/validators";

function getToken() {
    return localStorage.getItem('token')
}

function setToken(accessToken) {
    localStorage.setItem('token', accessToken)
}

function isAuthentificated() {
    return !!getToken()
}

function logout() {
    localStorage.removeItem('token')
    window.location.reload()
}

async function createUser(form) {
    if (!validateSignupForm(form)) {
        throw new Error()
    }
    try {
        const { data: { access_token } } = await $axios.post(APIS.USERS.CREATE, form)
        setToken(access_token)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function signIn(form) {
    if (!validateSigninForm(form)) {
        throw new Error()
    }
    try {
        const { data: { access_token } } = await $axios.post(APIS.USERS.SIGN_IN, form)
        setToken(access_token)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function getCurrentUser() {
    try {
        return await $axios.get(APIS.USERS.GET_USER)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function updateCurrentUser(form, allowEmptyFields = false) {
    try {
        const formData = allowEmptyFields ? form : getAllFilledFields(form)
        await $axios.patch(APIS.USERS.UPDATE_USER, formData)
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

async function changePassword(form) {
    if (!validateChangePasswordForm(form)) {
        throw new Error('Please fill all required fields')
    }
    const { old_password, new_password, new_password_confirm } = form
    if (new_password !== new_password_confirm) {
        throw new Error('New password must be the same')
    }
    try {
        await $axios.post(APIS.USERS.CHANGE_PASSWORD, {
            old_password,
            new_password
        })
    } catch (error) {
        throw new Error(getErrorMessageFromApi(error))
    }
}

export {
    createUser,
    getCurrentUser,
    updateCurrentUser,
    changePassword,
    signIn,
    isAuthentificated,
    getToken,
    logout
}